import {
  doc,
  collection,
  updateDoc,
  arrayUnion,
  increment,
  setDoc,
  getDoc,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../../firebase.js";
import Swal from "sweetalert2";

const HandleDreamList = async (item, userId, dreams, setDreams) => {
  const itemRef = doc(db, "JourneyItems", item.objectID);
  const userRef = doc(db, "Users", userId);
  let selectedListName;
  let newListId;

  const dreamItem = {
    objectID: item.objectID,
    name: item.name || null,
    country: item.country || null,
    city: item.city || null,
    state: item.state || null,
    category: item.category || null,
    userName: item.userName || null,
    userId: item.userId || null,
    dreamImage: item.imageUrl || null,
    countryCodes: item.countryCode || null,
  };

  // Fetch existing lists from the DreamLists collection
  const q = query(collection(db, "DreamLists"), where("userId", "==", userId));
  const querySnapshot = await getDocs(q);
  const dreamLists = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  const listNames = dreamLists.map((list) => list.name);

  // First Modal: Select Existing List or Create New
  const { value: selectedList } = await Swal.fire({
    title: "Add to Dream List",
    input: "select",
    inputOptions: {
      ...listNames.reduce((acc, name) => {
        acc[name] = name;
        return acc;
      }, {}),
      new: "Create new list",
    },
    inputPlaceholder: "Select a list",
    showCancelButton: true,
    confirmButtonText: "Add",
    cancelButtonText: "Cancel",
    width: "400px",
  });

  if (selectedList) {
    let selectedListName; // Declare the variable before using it

    if (selectedList === "new") {
      // Second Modal: Enter New List Name
      const { value: newListName } = await Swal.fire({
        title: "Create New List",
        input: "text",
        inputPlaceholder: "Enter new list name",
        showCancelButton: true,
        confirmButtonText: "Create",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value.trim()) {
            return "Please enter a name for the new list";
          }
        },
        width: "400px",
      });

      if (newListName) {
        selectedListName = newListName.trim();
      } else {
        return; // User cancelled the creation
      }
    } else {
      selectedListName = selectedList;
    }

    // Update the item in the database
    await updateDoc(itemRef, {
      dreams: arrayUnion(userId),
      totalDreams: increment(1),
    });

    // Add the item to the user's dream list
    const listIndex = dreamLists.findIndex(
      (list) => list.name === selectedListName
    );

    if (listIndex > -1) {
      // List exists, add the item to the list
      const listRef = doc(db, "DreamLists", dreamLists[listIndex].id);
      await updateDoc(listRef, {
        items: arrayUnion(dreamItem),
      });
    } else {
      // List does not exist, create a new list with Firestore's auto-generated ID
      const newListRef = doc(collection(db, "DreamLists"));
      newListId = newListRef.id;

      await setDoc(newListRef, {
        name: selectedListName,
        userId: userId,
        id: newListId, // Store the ID in the document
        items: [dreamItem],
      });

      // Add the new list reference to the user's document
      await updateDoc(userRef, {
        dreamLists: arrayUnion(newListId),
      });
    }

    setDreams(!dreams);
    Swal.fire(
      "Added!",
      "The item has been added to your dream list.",
      "success"
    );

    // Return the new list ID for later use
    return newListId;
  }
};

export default HandleDreamList;
